import { getStorage, type FirebaseStorage } from 'firebase/storage';
import { firebaseApp } from './firebaseApp.js';

export const getFirebaseStorage = (): FirebaseStorage | undefined => {
  if (!firebaseApp) return undefined;
  try {
    return getStorage(firebaseApp);
  } catch {
    return undefined;
  }
};

export const firebaseStorage = getFirebaseStorage();
